import React from "react";
import { Button, Card, Container } from "reactstrap";
import { Link } from "react-router-dom";
const TermsAndConditionForAthlete = () => {
  return (
    <>
      <Container fluid className="term-and-condition-main">
        <div className="py-4 px-1 px-sm-4">
          <Link to="/home-for-athlete">
            <Button color="primary">Back</Button>
          </Link>
        </div>
        <Card className="p-3 mx-auto" style={{ maxWidth: "900px" }}>
          <div className="mx-2">
            <h2 className="mb-3 terms-title text-primary">
              Option for Making Quick Change to Your Chat Rate:
            </h2>
            <p className="termsPoint">
              If you receive a message from a Fan who is registered at FHP and
              wants to VIDEO CHAT with you 'NOW',i.e.,immediately, you can Use
              'Off platform to site' to make a change to your chat rate for that
              Instant Chat if you like,provided you do so before you and the Fan
              agree on chat terms.
            </p>
          </div>
        </Card>
      </Container>
    </>
  );
};

export default TermsAndConditionForAthlete;
